import React from "react";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";
import { css } from "@emotion/css";

type Props = {
  value: string;
  onChange: (value: string) => void;
  onCommit: (value?: string) => void;
  placeholder: string;
};

const SearchField: React.VFC<Props> = ({ value, onChange, onCommit, placeholder }) => (
  <TextField
    size="small"
    variant="outlined"
    placeholder={placeholder}
    value={value}
    onChange={e => onChange(e.target.value)}
    onKeyDown={e => e.key === "Enter" && onCommit()}
    fullWidth
    className={styles.searchField}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton size="small" onClick={() => onCommit()} edge="end">
            <SearchIcon fontSize="small" />
          </IconButton>
        </InputAdornment>
      ),
    }}
  />
);

export default SearchField;

const styles = {
  searchField: css`
    & .MuiOutlinedInput-root {
      background: white;
    }
    & .MuiOutlinedInput-input {
      padding: 6px 10px;
      font-size: 0.8125rem;
    }
    & .MuiIconButton-root {
      padding: 2px;
    }
  `,
};
